import Portal from "Utilities/PortalMaker";
import { usePortalElement } from "Utilities/PortalMaker/usePortalElement";

import Squiggle from ".";

const SquigglePortal = () => {
  const portalElement = usePortalElement("#squiggle_holder");

  if (!portalElement) return null; // non-React area hasn't loaded yet

  return (
    <Portal to={portalElement}>
      <Squiggle />
    </Portal>
  );
};

export default SquigglePortal;
